import { render, staticRenderFns } from "./SettingTax.vue?vue&type=template&id=261b5b54"
import script from "./SettingTax.vue?vue&type=script&lang=js"
export * from "./SettingTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports